const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/actions/appointmentAttachment.ts';
import { kisapiActionTypes } from '@cistec/common_web/defs/actionTypes';
import { createPatapiCall, HttpMethod } from 'App/utils/fetchUtils';

export const LOAD_APPOINTMENT_ATTACHMENTS = kisapiActionTypes('PATAPP_LOAD_APPOINTMENT_ATTACHMENTS');

export function actionLoadAppointmentsAttachments(TerminList: string[]) {
    const body = { TerminList };
    return createPatapiCall(
        LOAD_APPOINTMENT_ATTACHMENTS,
        'appointments/attachments',
        HttpMethod.POST,
        undefined,
        JSON.stringify(body)
    );
}
